
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { blogCategories } from '@/data/blogPosts';

const BlogSidebar = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle>Search</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex">
            <Input placeholder="Search blog..." className="rounded-r-none" />
            <Button variant="default" className="rounded-l-none">
              Search
            </Button>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-3">
          <CardTitle>Categories</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2">
            {blogCategories.map((category) => (
              <li key={category.slug}>
                <Link 
                  to={`/blog/category/${category.slug}`}
                  className="text-gray-700 hover:text-blue-600 transition-colors"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-3">
          <CardTitle>Recent Posts</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-3">
            <li>
              <Link to="/blog/top-calculators-for-financial-planning" className="text-sm hover:text-blue-600 transition-colors">
                Top Calculators for Financial Planning
              </Link>
              <p className="text-xs text-gray-500">May 15, 2025</p>
            </li>
            <li>
              <Link to="/blog/how-to-calculate-your-mortgage-correctly" className="text-sm hover:text-blue-600 transition-colors">
                How to Calculate Your Mortgage Correctly
              </Link>
              <p className="text-xs text-gray-500">May 10, 2025</p>
            </li>
            <li>
              <Link to="/blog/why-bmi-calculators-are-important" className="text-sm hover:text-blue-600 transition-colors">
                Why BMI Calculators Are Important
              </Link>
              <p className="text-xs text-gray-500">May 5, 2025</p>
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default BlogSidebar;
